const APIUrl= "https://go.basevik.com/"

export default  APIUrl;